import { Directive, ViewContainerRef, ElementRef } from '@angular/core';
import { RowOutlet } from '../table.interfaces';

/**
 * @deprecated
 */
// tslint:disable-next-line:directive-selector
@Directive({ selector: '[footerRowOutlet]' })
export class FooterRowOutletDirective implements RowOutlet {
  constructor(
    public viewContainer: ViewContainerRef,
    public elementRef: ElementRef
  ) {}
}
